import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ParametrosMaestro } from 'src/app/models/common/enumModel';
import { ITipoVisitaModel } from 'src/app/models/interfaces/tipo-visita/ITipoVisitaModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { TipoVisitaModel } from 'src/app/models/tipo-visita/TipoVisitaModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { TipoVisitaService } from 'src/app/services/tipo-visita/tipo-visita.service';

@Component({
  selector: 'app-configuracion-tipo-visita-editar',
  templateUrl: './configuracion-tipo-visita-editar.component.html',
  styleUrls: ['./configuracion-tipo-visita-editar.component.css'],
})
export class ConfiguracionTipoVisitaEditarComponent implements OnInit {
  id: number = 0;
  model: ITipoVisitaModel = new TipoVisitaModel();
  listaEstados: ParametroModel[] = new Array<ParametroModel>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private tipoVisitaService: TipoVisitaService,
    private serviceParametros: ParametroService,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.id = params['id'];
    });

    this.serviceParametros.getDetalles(ParametrosMaestro.ESTADO_CONFIG_TIPO_VISITA).subscribe((data) => {
      this.listaEstados = data.items;
    });

    this.tipoVisitaService.getById(this.id).subscribe((data) => {
      this.model = data;
    });
  }

  onSubmit(form: NgForm) {
    if (!form.invalid) {
      this.confirmDialogService.open('¿Deseas guardar los cambios?'); //options
      this.confirmDialogService.confirmed().subscribe((confirmed) => {
        if (confirmed) {
          this.tipoVisitaService.update(this.model).subscribe((data) => {
            this.alertDialogService.open('El tipo de visita fue actualizado'); //options
            this.router.navigate(['/configuracion', 'tipo-visitas']);
          });
        }
      });
    }
  }
}
